module.exports = __webpack_public_path__ + "img/paradis.37fb8c25.jpg";